var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service",attrs:{"id":_vm.mtype}},[_c('img',{attrs:{"src":require('@/assets/pic/service/'+_vm.mtype+'.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }